module.exports = __webpack_public_path__ + "static/media/theGameLaFunc.4af44745.png";